export function export2Excel(columns, list) {
  require.ensure([], () => {
    const {
      export_json_to_excel
    } = require('../../excel/Export2Excel');
    let tHeader = []
    let filterVal = []
    console.log(columns)
    if (!columns) {
      return;
    }
    columns.forEach(item => {
      tHeader.push(item.title)
      filterVal.push(item.key)
    })
    const data = list.map(v => filterVal.map(j => v[j]))
    const date = new Date()
    // export_json_to_excel(tHeader, data, '数据列表' + date.getFullYear()+'-'+date.getMonth()+'-'+date.getDate()+'- '+date.getHours()+':'+date.getMinutes()+':'+date.getSeconds());
    export_json_to_excel(tHeader, data, '数据列表' + formatTime(date));
  })
};
export function formatTime(val, fmStr) {
  let yy = new Date().getFullYear();
  var mm =
    new Date().getMonth() < 10 ?
    "0" + (new Date().getMonth() + 1) :
    new Date().getMonth() + 1;
  var dd =
    new Date().getDate() < 10 ?
    "0" + new Date().getDate() :
    new Date().getDate();
  let hh = new Date().getHours();
  let mf =
    new Date().getMinutes() < 10 ?
    "0" + new Date().getMinutes() :
    new Date().getMinutes();
  let ss =
    new Date().getSeconds() < 10 ?
    "0" + new Date().getSeconds() :
    new Date().getSeconds();
  return yy + "-" + mm + "-" + dd + " " + hh + ":" + mf + ":" + ss;
}
